/* ---------- Tiny cookie + newsletter bar (30 Oct 2026) ----------
   A slim pill (30px tall, under 1 cm) slides up once, a few seconds after the first visit.
   Left: cookies OK / no (Shopify customer-privacy consent). Right: newsletter email (Shopify customer + "newsletter" tag).
   Each side disappears once answered; the bar slides away when both are done or it's closed, and doesn't come back. */
(function () {
  if (/\/(checkouts?|challenge|account)/.test(location.pathname)) return;
  var get = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var put = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
  var needCk = !get('fl_ck'), needNl = !get('fl_nl');
  if (!needCk && !needNl) return;

  var css = document.createElement('style');
  css.textContent =
    '.flcb{position:fixed;left:50%;bottom:calc(10px + env(safe-area-inset-bottom,0px));z-index:2147483000;display:flex;align-items:center;gap:8px;height:30px;max-width:calc(100% - 16px);padding:0 6px 0 12px;border-radius:999px;background:#111213;color:#fff;font:500 12px/1 system-ui,-apple-system,"Segoe UI",sans-serif;box-shadow:0 6px 20px rgba(0,0,0,.25);transform:translate(-50%,160%);transition:transform .45s cubic-bezier(.2,.8,.2,1);white-space:nowrap;box-sizing:border-box}' +
    '.flcb.is-up{transform:translate(-50%,0)}' +
    '.flcb__side{display:flex;align-items:center;gap:6px;flex:0 0 auto}.flcb form.flcb__side{flex:1 1 auto;min-width:0}' +
    '.flcb__sep{width:1px;height:16px;background:rgba(255,255,255,.25)}' +
    '.flcb a{color:#fff;text-decoration:underline;text-underline-offset:2px}' +
    '.flcb button{flex:0 0 auto;border:0;border-radius:999px;height:22px;padding:0 10px;font:700 11.5px/1 inherit;font-family:inherit;cursor:pointer}' +
    '.flcb__yes{background:#E5202B;color:#fff}.flcb__no{background:rgba(255,255,255,.14);color:#fff}' +
    '.flcb input{flex:1 1 150px;height:22px;width:150px;min-width:64px;border:0;border-radius:999px;padding:0 10px;font:500 12px/1 inherit;font-family:inherit;color:#111213;background:#fff;outline:none}' +
    '.flcb__x{background:transparent!important;color:rgba(255,255,255,.7)!important;padding:0 6px!important;font-size:15px!important}' +
    '.flcb__ok{color:#9BE3B4;font-weight:700}' +
    '@media (max-width:520px){.flcb{gap:5px;padding:0 4px 0 10px;font-size:11px;width:calc(100% - 16px)}.flcb input{width:80px;flex-basis:80px;padding:0 8px;font-size:11px}.flcb__lbl2,.flcb__q{display:none}.flcb button{padding:0 8px;font-size:11px}}' +
    '@media (prefers-reduced-motion:reduce){.flcb{transition:none}}';
  document.head.appendChild(css);

  var bar = document.createElement('div');
  bar.className = 'flcb'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Cookies and newsletter');
  bar.innerHTML =
    (needCk ? '<div class="flcb__side" data-ck><span>🍪 <a href="/policies/privacy-policy">Cookies</a><span class="flcb__q"> OK</span>?</span><button type="button" class="flcb__yes" data-ck-yes>Yes</button><button type="button" class="flcb__no" data-ck-no>No</button></div>' : '') +
    (needCk && needNl ? '<span class="flcb__sep" data-sep></span>' : '') +
    (needNl ? '<form class="flcb__side" data-nl novalidate><span class="flcb__lbl2">Newsletter</span><input type="email" name="email" placeholder="Your email" aria-label="Email for the newsletter" autocomplete="email" required><button type="submit" class="flcb__yes">Join</button></form>' : '') +
    '<button type="button" class="flcb__x" data-x aria-label="Close">×</button>';

  function done(side) {
    var el = bar.querySelector(side); if (el) el.remove();
    var sep = bar.querySelector('[data-sep]'); if (sep) sep.remove();
    if (!bar.querySelector('[data-ck]') && !bar.querySelector('[data-nl]')) hide();
  }
  function hide() { bar.classList.remove('is-up'); setTimeout(function () { bar.remove(); }, 500); }
  function flash(side, text, after) {
    var el = bar.querySelector(side); if (!el) return;
    el.innerHTML = '<span class="flcb__ok">' + text + '</span>';
    setTimeout(function () { done(side); }, after || 1400);
  }

  /* Cookies: tell Shopify (analytics, marketing and preferences follow the choice). */
  function consent(yes) {
    put('fl_ck', yes ? 'yes' : 'no');
    var apply = function () {
      try { window.Shopify.customerPrivacy.setTrackingConsent({ analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes }, function () {}); } catch (e) {}
    };
    if (window.Shopify && window.Shopify.customerPrivacy) apply();
    else if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (!err) apply(); });
    flash('[data-ck]', yes ? 'Thanks ✓' : 'Got it ✓');
  }

  /* Newsletter: the same submission as a Shopify newsletter form. If Shopify asks for a quick check, the page opens it. */
  function subscribe(form) {
    var input = form.querySelector('input'), email = String(input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { input.focus(); input.style.boxShadow = '0 0 0 2px #E5202B'; return; }
    var fields = { form_type: 'customer', utf8: '✓', 'contact[email]': email, 'contact[tags]': 'newsletter, cookie bar', 'contact[accepts_marketing]': 'true' };
    var fd = new FormData(); Object.keys(fields).forEach(function (k) { fd.append(k, fields[k]); });
    var real = function () {
      var f = document.createElement('form'); f.method = 'post'; f.action = '/contact#flcb'; f.style.display = 'none';
      Object.keys(fields).forEach(function (k) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = fields[k]; f.appendChild(i); });
      document.body.appendChild(f); put('fl_nl', 'joined'); f.submit();
    };
    form.querySelector('button').disabled = true;
    fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).then(function (r) {
      if (r.ok && /customer_posted=true/.test(r.url)) { put('fl_nl', 'joined'); flash('[data-nl]', 'You’re in ✓'); }
      else real();
    }).catch(real);
  }

  bar.addEventListener('click', function (e) {
    if (e.target.closest('[data-ck-yes]')) consent(true);
    else if (e.target.closest('[data-ck-no]')) consent(false);
    else if (e.target.closest('[data-x]')) { if (needNl && !get('fl_nl')) put('fl_nl', 'closed'); if (needCk && !get('fl_ck')) put('fl_ck', 'closed'); hide(); }
  });
  bar.addEventListener('submit', function (e) { e.preventDefault(); subscribe(e.target); });

  /* Sit just above the phone tab bar, the desktop dock or the floating sale button, so nothing overlaps. */
  function lift() {
    var ofs = 10, b = bar.getBoundingClientRect();
    ['.flapp-tabs', '.fl-dock', '#flbf-float', '.fw__foot', '.bf-mini'].forEach(function (s) {
      var el = document.querySelector(s); if (!el || el.hidden) return;
      var cs = getComputedStyle(el); if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position !== 'fixed') return;
      var r = el.getBoundingClientRect(); if (!r.height || r.top >= innerHeight || r.bottom < innerHeight - 200) return;
      if (r.right < b.left || r.left > b.right) return;
      ofs = Math.max(ofs, innerHeight - r.top + 8);
    });
    bar.style.bottom = ofs + 'px';
  }
  function show() { document.body.appendChild(bar); lift(); window.addEventListener('resize', lift); requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.add('is-up'); }); }); }
  if (document.readyState === 'complete') setTimeout(show, 2500); else window.addEventListener('load', function () { setTimeout(show, 2500); });
})();
